export default "__VITE_ASSET__CruNKcsJ__"